import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center p-8 ek-scanline">
      <div className="w-full max-w-md border rounded-lg p-8 text-center" style={{ background: "var(--ek-surface)", borderColor: "var(--ek-border)" }} data-testid="payment-cancel">
        <XCircle className="h-10 w-10 mx-auto mb-4" style={{ color: "var(--ek-steel)" }} />
        <h1 className="font-head font-bold text-xl tracking-tight mb-2">Checkout cancelled</h1>
        <p className="text-sm mb-6" style={{ color: "var(--ek-text-secondary)" }}>No charge was made. You can start your free trial whenever you're ready.</p>
        <Button onClick={() => navigate("/")} data-testid="cancel-back-btn" className="w-full rounded-md" style={{ background: "var(--ek-primary)", color: "#fff" }}>Back to plans</Button>
      </div>
    </div>
  );
}
